import { isLegendOpenSelector } from '@/redux/legend/legend.selectors';
import { store } from '@/redux/store';

export const isLegendOpen = (): boolean => {
  const { getState } = store;

  return isLegendOpenSelector(getState());
};
